<template>
    <b-modal
        id="office-file-preview-modal"
        v-model="model"
        modal-class="apprentice-default-modal office-preview"
        title="Voorbeeld document"
        :ok-title="$t('common.close')"
        ok-only
        hide-footer
        no-close-on-backdrop>
        <template #modal-header="{ close }">
            <h5 class="title">{{ file.name }}</h5>
            <b-button
                class="btn-close btn-modal-close close"
                variant="primary"
                @click="close()">
            </b-button>
        </template>

        <div
            class="file-content"
            v-if="model">
            <div
                class="embed-pdf"
                id="pdf"
                v-if="isSourceTypePdf"></div>

            <b-embed
                class="file-embed"
                v-else-if="isSourceUrlSupported"
                type="iframe"
                aspect="16by9"
                :src="getSourceUrl"
                allowfullscreen>
            </b-embed>

            <div
                class="not-supported-format"
                v-else>
                <div class="exclamation-icon icon">
                    <i class="fas fa-times-circle"></i>
                </div>
                <h6>Bestand wordt niet ondersteund, er kan geen preview van gemaakt worden.</h6>
                <p>
                    Klik
                    <b-button
                        class="btn-file-download"
                        variant="link"
                        @click="downloadFile(file.id)"
                        :download="file.public_path">
                        hier
                    </b-button>
                    om het bestand te donwloaden.
                </p>
            </div>
        </div>
    </b-modal>
</template>

<script>
import PDFObject from 'pdfobject';

export default {
    name: 'design-2021-apprentice-preview-office-file-component',
    props: {
        showEditLink: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            file: null,
            supportedMimeTypes: ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'xlx'],
            isSourceTypePdf: false,
            model: false,
            isSourceUrlSupported: false,
        };
    },

    methods: {
        show(file) {
            this.file = file;
            this.isSourceUrlSupported =
                file.path.includes('amazonaws.com') && this.supportedMimeTypes.includes(file.extension.toLowerCase());
            this.isSourceTypePdf = file.extension.toLowerCase() === 'pdf';
            this.model = true;

            if (this.model && this.isSourceTypePdf) {
                this.$nextTick(() => {
                    PDFObject.embed(this.file.public_path, '#pdf', { height: 'calc(95dvh - 75px)' });
                });
            }
        },

        downloadFile(id) {
            window.open(this.routes.assignmentAnswerFileDownload(id), '_blank');
        },
    },

    computed: {
        getSourceUrl() {
            const officeUrl = 'https://view.officeapps.live.com/op/embed.aspx?src=';

            if (this.isSourceUrlSupported) {
                return officeUrl + this.file.public_path;
            }
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .office-preview {
    header.modal-header {
        flex-wrap: wrap;
        row-gap: map-get($grid-gutter-spacing, 'fifteen');

        .btn-close {
            color: var(--primary);

            &:hover {
                background-color: transparent;
                box-shadow: none;
                color: var(--primaryLightest);
            }
        }

        .edit-file {
            display: flex;
            justify-content: flex-end;
            flex: 1 0 100%;

            .btn {
                padding: 0;
                border: none;
                background-color: transparent;
                color: var(--primary);

                &:hover {
                    border: none;
                    box-shadow: none;
                    outline: none;
                    color: var(--primaryLightest);
                }
            }
        }
    }

    .modal-dialog {
        width: 95vw;
        max-width: 100%;
        height: calc(95dvh - 75px);
        margin: auto;
    }

    .file-content {
        .embed-responsive {
            height: calc(95dvh - 75px);
        }

        .not-supported-format {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            row-gap: $grid-gutter-width;

            h6 {
                margin-bottom: 0;
            }

            p {
                margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            }

            .exclamation-icon {
                flex: 1 0 100%;
                color: $danger;
                font-size: 2rem;
            }

            .btn {
                line-height: 1;
            }
        }
    }
}
</style>
